import { StatusOption } from '../../utils'

export enum StaffApplicationLanguageEnum {
  FRENCH = 'FRENCH',
  ENGLISH = 'ENGLISH'
}

export const staffApplicationLanguageEnumMapping: Record<
  StaffApplicationLanguageEnum,
  StatusOption
> = {
  FRENCH: {
    label: 'Français',
    variant: 'blue'
  },
  ENGLISH: {
    label: 'Étranger',
    variant: 'secondaryDarkBlue'
  }
}
